import { useEffect, useState } from 'react'

const useIsDesktop = (width) => {
  const [isDesktop, setIsDesktop] = useState(() => window.matchMedia(`(min-width: ${width || 992}px)`).matches)
  useEffect(() => {
    // Create listeners for each media query returning a function to unsubscribe
    function handlers() {
      const mql = window.matchMedia(`(min-width: ${width || 992}px)`)

      const handler = (matchMediaQuery) => {
        setIsDesktop(matchMediaQuery.matches)
      }

      // Safari < 14 fix
      if (mql.addEventListener) {
        mql.addEventListener('change', handler)
      }

      return () => {
        // Safari < 14 fix
        if (mql.removeEventListener) {
          mql.removeEventListener('change', handler)
        }
      }
    }
    handlers()

    return () => {
      handlers()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return isDesktop
}

export default useIsDesktop
